<template>
  <div class="protocol">
    Last revised on April 1, 2025
    <br /><br />

    <div class="bt" style="text-align: center">
      {{ appName }}'s Privacy Policy
    </div>
    <div>
      Welcome to {{ appName }} (the "Platform" or "APP"). The Platform is
      provided and controlled by {{ appName }}. ("{{ appName }}", "we" or "us").
      We are committed to protecting and respecting your privacy. This Policy
      explains our practices regarding personal data we collect from you or that
      you provide to us. If you do not agree to this Policy, you should not use
      the Platform. <br /><br />
      Please read this Privacy Policy carefully to understand how we will treat
      your information before you start using our services or communicating with
      us outside of the Platform. Certain features or functions of our Platform
      may be provided through the Platform. This Privacy Policy applies to the
      collection and use of data about you and your use of the Platform.
      (However, we may provide additional notices and choices, options.)
      <br /><br />
      By accessing or using our Platform, you accept and consent to the
      practices described in this Privacy Policy, which may be updated and
      revised from time to time. If you do not agree to the terms of this
      Privacy Policy, you must not access or use the Platform.
      <br /><br />
    </div>

    <div class="bt">1.What Information We Collect</div>
    <div>
      When you create an account and use the Platform, we collect information,
      such as your contact details, the content you create, and your location.
      We also collect information you share with us from third-party social
      networking providers, as well as technical and behavioral information
      about your use of the Platform. We also collect information contained in
      messages you send through our Platform.
      <br /><br />
    </div>
    <div class="bt subtitle">Information You Choose to Provide</div>
    <div>
      For certain activities, such as when you register, upload content to the
      Platform, or contact us directly, you may provide some or all of the
      following information: Registration information, such as language Profile
      information, such as name, social media account information, and profile
      picture User-generated content you choose to upload or broadcast on the
      Platform, including comments, photos (“User Content”) Payment information,
      such as Apple and Google in-app purchases Your opt-ins and communication
      preferences Information in communications you send to us Information you
      share by taking surveys or entering challenges, sweepstakes, or contests,
      such as your gender, age, likeness, and preferences. Information We Get
      from Other Sources We may receive information about you from other
      sources. For example, if you choose to link or register using your social
      network, such as Facebook, we may collect information from those
      third-party services, including your contact lists on those services and
      information related to your use of the Platform. We also receive
      information about you (including age data and demographic information)
      from third parties, such as advertising networks and analytics providers,
      and from other sources, including business directories and other
      commercial or publicly available sources.
      <br /><br />
    </div>
    <div class="bt subtitle">Information We Collect Automatically</div>
    <div>
      When you use the Platforms, we automatically collect certain information
      about you, including your IP address, location-related data (as described
      below), unique device identifiers, browsing history (including content you
      have viewed within the Platforms), Cookies (as defined below), your mobile
      carrier, time zone settings, and mobile or device information, including
      your device model, screen resolution, operating system, application and
      file names and types, and platform.
      <br /><br />
    </div>
    <div class="bt subtitle">Usage Information</div>
    <div>
      We collect information about your use of the Platforms and any other user
      content you generate through and broadcast on our Platforms. We also use
      your phone number or similar information to associate your subscriber
      information with your activity across all devices.
      <br /><br />
    </div>
    <div class="bt subtitle">Messages</div>
    <div>
      We collect and process (including scanning and analyzing) the information
      you provide when you compose, send, or receive messages through the
      messaging features of our Services. This information includes the content
      of the message and information about when the message was sent, received,
      and/or read, and the participants in the communication. Please note that
      messages sent to other users of our Services will be accessible to those
      users, and we are not responsible for how those users use or disclose the
      messages.
      <br /><br />
    </div>
    <div class="bt subtitle">Metadata</div>
    <div>
      When you upload User Content, certain metadata connected to your User
      Content is automatically uploaded. Metadata describes other data and
      provides information about your User Content that is not always obvious to
      the viewer. In the case of your User Content, metadata may describe how,
      when, and by whom the User Content was collected, and how that content is
      formatted. It also includes information such as your account name or user
      ID number, which enables other users to trace content back to your user
      account. In addition, metadata will include data you choose to provide
      with your content, such as any hashtags used to tag keywords to content
      and captions.
      <br /><br />
    </div>
    <div class="bt subtitle">Buy Coins</div>
    <div>
      Your purchases will be made through your Google Play account or other
      authorized payment methods. We do not collect any financial or billing
      information from you in connection with such transactions. Please review
      the relevant terms and notices regarding the processing of such
      information. In order to credit your account with the correct Coin value,
      we will record your purchases, when they were made, and how much you
      spent.
      <br /><br />
    </div>
    <div class="bt subtitle">Cookies</div>
    <div>
      We and our service providers and business partners use cookies and other
      similar technologies ("Cookies") to automatically collect information,
      measure and analyze the pages you click on and how you use the Platform,
      enhance your experience using the Platform, and improve the Platform.
      Cookies are small files that, when placed on your device, enable the
      Platform to provide certain features and functionality. To learn how to
      disable cookies, see the "Your Choices" section below.
      <br /><br />
    </div>
    <div class="bt">2.How We Use Your Information</div>
    <div>
      We use your information to fulfill and enforce our Terms of Service,
      improve and administer the Platform, and allow you to use its features. We
      may also use your information to show you recommendations. We generally
      use the information we collect to: Fulfill internal operational requests
      for products, services, Platform features, support, and information,
      including troubleshooting, data analysis, testing, research, statistical
      and survey purposes, and solicit your feedback Customize the content you
      see when you use the Platform. For example, we may provide you with
      services based on your selected country settings or show you content
      similar to content you like or interact with Improve and develop our
      Platform and conduct product development Support the social features of
      the Platform, including allowing you and other users to connect with each
      other through the Platform and for you and other users to share, download
      and otherwise interact with User Content posted through the Platform Help
      us detect abuse, fraud and illegal activity on the Platform Ensure you are
      of age to use the Platform (as required by law) Communicate with you,
      including notifying you of changes to our Services Announce you as the
      winner of our contests, sweepstakes or promotions (if permitted by the
      promotion rules) and send you any applicable prizes Enforce our terms,
      conditions and policies Provide you with location-based services, such as
      personalized content, consistent with your permissions Inform our
      algorithms Combining all information we collect or receive about you for
      any of the purposes listed above for any other purpose disclosed to you at
      the time we collect your information or with your consent.
      <br /><br />
    </div>
    <div class="bt">3.How we share your information</div>
    <div>
      We are committed to maintaining your trust and want you to understand when
      and with whom we share the information we collect. We will share your
      information with the following selected third parties: Authorized
      third-party vendors and service providers. We share your information with
      third-party vendors and service providers who help us with our business
      operations, including research, payment processing and transaction
      fulfillment, database maintenance, contest administration, technical
      services, delivery, analytics, data storage and hosting, disaster
      recovery, search engine optimization, marketing, and data processing.
      Legal Purposes. We may disclose information to respond to subpoenas, court
      orders, legal process, law enforcement requests, legal claims, or
      government inquiries, and to protect and defend the rights, interests,
      safety, and security of our affiliates, users, or the public. With Your
      Consent. We may share information for any other purpose disclosed to you
      at the time the information is collected or with your consent. If you
      access third-party services (such as Facebook, Google, etc.) to log into
      the Platform or share your use information on the Platform with others,
      these third-party services may collect information about you, including
      information about your activity on the Platform, and they may notify your
      connections on the third-party services about your use of the Platform, in
      accordance with their privacy policies. If you choose to participate in
      public activities on the Platform, you should be aware that any
      information you share may be read, collected, or used by other users. You
      should be careful about disclosing personal information when
      participating. We are not responsible for the information you choose to
      submit.
      <br /><br />
    </div>
    <div class="bt">4.Your Rights</div>
    <div>
      You can refuse or disable cookies by adjusting your browser settings.
      Because each browser is different, please consult the instructions
      provided by your browser. Please note that you may need to take additional
      steps to refuse or disable certain types of cookies. For example, because
      browsers and mobile applications operate differently, you may need to take
      different steps to opt out of cookies for login information in your
      browser, and to opt out of login information for mobile applications,
      which you can control through your device settings or mobile application
      permissions. In addition, your opt-out choices include specific to the
      specific browser or device you use when you opt out, so you may need to
      opt out separately for your browser or device. If you choose to refuse,
      disable or delete cookies, certain features of the Platform may no longer
      be available to you. If you have registered an account, you may be able to
      access, review and update certain personal information that you have
      provided to us by logging into your account and using available features,
      as well as features. How to Delete Your Account and Data To request
      deletion of your account and related data, please submit a verified
      request to our support team at {{ appEmail }}. We require documentation
      proving your ownership of your account, which may include, but is not
      limited to: government-issued ID matching account details, recent
      transaction records, or device verification codes. All deletion requests
      will be processed within 72 hours of successful verification, with an
      official data erasure certificate available through our compliance portal
      upon completion. We will only retain your personal information as long as
      it is required by legal basis and permitted by applicable law. You can
      permanently delete your account and data at any time. <br /><br />
    </div>
    <div class="bt">5.Data Security</div>
    <div>
      We take appropriate administrative, technical, and physical security
      measures to protect your personal information from unauthorized access and
      disclosure. For example, only authorized employees have access to personal
      information, and they may only access personal information for permitted
      business functions. In addition, we use encryption technology when certain
      personal information is transmitted between your system and ours, and use
      firewalls to help prevent unauthorized access to your personal
      information. Please note, however, that we cannot completely eliminate
      security risks associated with the storage and transmission of your
      personal information. You should exercise caution when submitting
      information through {{ appName }} Services and should be particularly
      careful when deciding what information to provide to us. <br /><br />
    </div>
    <div class="bt">6.Data Retention</div>
    <div>
      We will retain your data in order to provide you with services. However,
      we may retain this data for longer periods of time in accordance with our
      legal obligations or where it is necessary to establish, exercise or
      defend legal claims. After you terminate your use of our platform, we will
      delete your information or store it in an anonymized format.
      <br /><br />
    </div>
    <div class="bt">7.Child Protection</div>
    <div>
      Our services are not intended for users under the age of 18, and we do not
      intentionally collect personal information from children under the age of
      18. If you are the parent or guardian of a child under the age of 18 and
      believe that he or she has disclosed personal information to us, please
      contact us immediately at {{ appEmail }}. If we learn that we have
      collected personal information from children under the age of 18, we will
      stop processing such information and take reasonable steps to delete the
      relevant information from our records in a timely manner. <br /><br />
    </div>
    <div class="bt subtitle">How we handle children's personal information</div>
    <div>
      Our products, websites and services are mainly for adults. Children are
      not allowed to create their own personal information subject accounts
      without the consent of their parents or guardians. For children's personal
      information collected with parental consent, we will only use or disclose
      this information when permitted by law, with the explicit consent of
      parents or guardians, or when necessary to protect children. Although
      local laws and customs define children differently, we consider anyone
      under the age of 18 to be a child. If we find that we have collected
      personal information of a child without first obtaining verifiable
      parental consent, we will try to delete the relevant data as soon as
      possible.
      <br /><br />
    </div>
    <div class="bt subtitle">Content Review and Behavior Management</div>
    <div>
      The platform adopts a combination of manual and machine review mechanisms,
      and does not allow content that is not suitable for minors: -
      Pornographic, violent, discriminatory or other content that is not
      suitable for minors. - Harassment, bullying, sexual innuendo or other
      illegal content targeting minors. If any illegal content or behavior is
      found, the platform will deal with it immediately, including deleting
      content, banning accounts, etc.
      <br /><br />
    </div>
    <div class="bt subtitle">Report and Feedback Mechanism</div>
    <div>
      The platform provides a convenient reporting and feedback channel: - Users
      can report or feedback inappropriate content or behavior at any time. -
      The reporting and feedback function is located in the upper right corner
      of each room, as well as in the upper right corner of the user profile
      page and Me-Feedback, so users can quickly report and feedback
      inappropriate content. - The platform promises to respond within 24 hours
      after receiving the report and make relevant penalties immediately. - Or
      contact us via email: {{ appEmail }} <br /><br />
    </div>
    <div class="bt subtitle">Violation handling and penalties</div>
    <div>
      For users who violate the policy on protection of minors, the platform
      will take the following penalties: - Immediately block the relevant
      account. - Delete illegal content and notify the victim. - Violators will
      be permanently banned from using the platform and may be subject to legal
      liability.
      <br /><br />
    </div>

    <div class="bt subtitle">Children's Privacy</div>
    <div>
      Tomo7i is committed to protecting children's privacy and safety.

      Tomo7i does not knowingly collect personal information from children who do not meet the minimum age requirements applicable in their region.

      Our service is intended for users who meet the applicable minimum age requirements. We do not knowingly allow children to use our platform in violation of applicable laws or child safety requirements.

      If we become aware that a child has provided personal information without appropriate authorization, we will take reasonable steps to delete such information.

      We also prohibit any form of Child Sexual Abuse and Exploitation (CSAE), including Child Sexual Abuse Material (CSAM), sexual exploitation of children, grooming, or other harmful activities involving minors.

      Users can report any suspected child safety concerns by contacting us:

      Email: tomo7ichat@gmail.com

      <br/><br/>
    </div>

    <div class="bt">8.Summary of device permission calls</div>
    <div>
      The following is a summary of the main permissions we need to provide
      services. You can choose to turn off some or all permissions in the device
      settings. Displaying and turning off permissions may vary from device to
      device. For more information, please refer to the device and system
      developer's instructions or guidelines:
      <br /><br />
    </div>
    <div class="table-container">
      <table>
        <tr>
          <td>Device Permission Functions</td>
          <td>Description of the device permissions function</td>
          <td>Description of functions and scenarios</td>
        </tr>
        <tr>
          <td>Network State</td>
          <td>
            We collect network connection state (Android. Permission.
            ACCESS_NETWORK_STATE) and WiFi state (Android. Permission.
            ACCESS_WIFI_STATE), as well as changes in network state (Android.
            Permission. CHANGE_NETWORK_STATE) or changes to WiFi state (Android.
            Permission. CHANGE_WIFI_STATE)
          </td>
          <td>Ensure application functionality and optimize network usage.</td>
        </tr>
        <tr>
          <td>Internet Access</td>
          <td>We need INTERNET access (android. Permission. INTERNET)</td>
          <td>Turn on Internet access for real-time reading and updates.</td>
        </tr>
        <tr>
          <td>Bluetooth Status</td>
          <td>
            We might visit BLUETOOTH state (android. Permission. BLUETOOTH and
            android. Permission. BLUETOOTH_CONNECT)
          </td>
          <td>Support Bluetooth device connection and data transmission.</td>
        </tr>
        <tr>
          <td>Audio Settings and Recordings</td>
          <td>
            We may change the audio Settings (android. Permission.
            MODIFY_AUDIO_SETTINGS) and recording function (android. Permission.
            RECORD_AUDIO)
          </td>
          <td>
            Provides a better audio experience with support for voice chat and
            other voice features.
          </td>
        </tr>
        <tr>
          <td>Camera</td>
          <td>We may visit the CAMERA (android. Permission. CAMERA)</td>
          <td>
            Captured when content is posted; captured when chatting with other
            users; captured during registration and identity verification; and
            when using other capture features.
          </td>
        </tr>
        <tr>
          <td>Storage Reading</td>
          <td>
            We may access the external storage of the device
            (android.permission.READ_EXTERNAL_STORAGE)
          </td>
          <td>
            To access images, files, and other content stored on your device,
            you agree that such access is primarily for accessibility purposes,
            including, but not limited to, posting information, uploading
            profile pictures or other images, uploading files, and logging
            crashes locally for diagnostic purposes.
          </td>
        </tr>
        <tr>
          <td>Storage Wrting</td>
          <td>
            We may access the external storage of the device
            (android.permission.WRITE_EXTERNAL_STORAGE)
          </td>
          <td>
            Writing, downloading, saving, caching, modifying or deleting images,
            files and other information is only used to enhance the user
            experience and ensure the normal operation of the application.
          </td>
        </tr>
        <tr>
          <td>Media Access</td>
          <td>
            We may access audio (android.permission.READ_MEDIA_AUDIO) and images
            (android.permission.READ_MEDIA_IMAGES) and video
            (android.permission.READ_MEDIA) _VIDEO).
          </td>
          <td>
            Assist you with functions such as capturing and publishing audio and
            video, changing profile pictures, and more
          </td>
        </tr>
        <tr>
          <td>Notifications and Reminders</td>
          <td>
            We may send notification (android. Permission. POST_NOTIFICATIONS
            and com. Google. Android. The c2dm. Permission. The RECEIVE)
          </td>
          <td>App updates and push messages</td>
        </tr>
      </table>
    </div>
    <br /><br />
    <div>
      How do I disable USE_FULL_SCREEN_INTENT?
      <br /><br />
      To remove the USE_FULL_SCREEN_INTENT permission on Android 14, follow
      these steps:
      <br /><br />
      1. Open your phone settings: Find and tap the phone's "Settings" icon on
      the home screen to enter the phone's settings page.
      <br /><br />
      2. Go to application management: On the "Settings" page, find the
      "Applications" or "Application Manager" option and click it. This will
      list all the applications you have installed on your phone.
      <br /><br />
      3. Select an application: Find the application you want to remove the
      "USE_FULL_SCREEN_INTENT" permission from the application list, and then
      tap the application to enter its application settings page.
      <br /><br />
      4. Manage permissions: In the application settings page, find the
      "Permissions" option and click to enter. In the permissions list, look for
      permissions related to full screen, which can be directly displayed as the
      "USE_FULL_SCREEN_INTENT" permission, or related expressions such as "Show
      full screen notifications".
      <br /><br />
      5. Disable permissions: Click the switch button next to the permission to
      disable it, and you can remove the "USE_FULL_SCREEN_INTENT" permission for
      the application. Once turned off, the app will no longer be able to use
      full-screen notifications.
      <br /><br />
      It should be noted that turning off permissions for certain apps may
      affect the use of their normal functions. Before doing so, make sure you
      understand the impact of disabling this permission on the app.
      <br /><br />
      2. Third Party<br />
      In order to conduct data statistics and anti-fraud measures, protect your
      account and transaction security, and provide you with a better chat and
      social experience, {{ appEmail }} may integrate third-party SDKs, such as
      Yunxin SDK and Yidun SDK. EasyShield SDK:
      https://dun.163.com/clause/privacy <br /><br />
    </div>
    <div class="bt">9.Changes</div>
    <div>
      We will generally notify all users of any material changes to this Policy
      through a notification on our Platform. However, you should review this
      Policy periodically to check for any changes. We will also update the
      "Last Revised" date at the top of this Policy, which reflects the
      effective date of such Policy. Your continued access or use of the
      Services after the date of the updated Policy constitutes your acceptance
      of the updated Policy. If you do not agree to the updated Policy, you must
      stop accessing or using the Services.
      <br /><br />
    </div>
    <div class="bt">10.Contact us</div>
    <div>
      If you have any questions about privacy protection, policy enforcement or
      platform operation, please send your comments or suggestions to our email
      {{ appEmail }}. We will review the issues involved and respond promptly.
      <br /><br />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
};
</script>

<style scoped>
.table-container {
  width: 100%; /* 或任何具体宽度 */
  overflow-x: auto;
}
table {
  border-collapse: collapse; /* 合并边框 */
  max-width: 100%;
  width: 100%;
  margin: 0.2267rem 0; /* 外边距 */
  font-family: Arial, sans-serif; /* 字体 */
}
td {
  padding: 0.2267rem; /* 内边距 */
  border: 1px solid #ddd; /* 边框 */
  word-wrap: break-word; /* 允许长单词换行 */
  white-space: normal; /* 允许内容换行 */
}

.protocol {
  /* overflow: hidden; */
  width: 100%;
  font-size: 0.9rem;
  margin-bottom: 0.4667rem;
  color: #666;
  padding-left: 0.4rem;
  padding-right: 0.4rem;
  box-sizing: border-box;
}
.bt {
  font-size: 1.3rem;
  margin: 0.2rem 0px;
  color: #000;
}
.subtitle {
  font-size: 1.1rem;
  color: #333;
}
</style>
